type toLocalStringInput = {
  date: string | Date;
  locale: string;
  timeZone: string;
};

export const toLocalString = ({ date, locale, timeZone }: toLocalStringInput) => {
  const inputDate = date instanceof Date ? date : new Date(date);

  if (Number.isNaN(inputDate.getTime())) {
    return {
      date: "",
      time: "",
    };
  }

  const base: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  };

  let formatter: Intl.DateTimeFormat;
  try {
    formatter = new Intl.DateTimeFormat(locale || "fr", base);
  } catch {
    formatter = new Intl.DateTimeFormat("fr", base);
  }

  const parts = formatter.formatToParts(inputDate);
  const timeTypes = new Set<Intl.DateTimeFormatPartTypes>(["hour", "minute", "second", "dayPeriod"]);
  const timeStartIndex = parts.findIndex((part) => timeTypes.has(part.type));

  let dateString: string;
  let timeString: string;

  if (timeStartIndex === -1) {
    dateString = parts
      .map((part) => part.value)
      .join("")
      .trim();
    timeString = "";
  } else {
    dateString = parts
      .slice(0, timeStartIndex)
      .map((part) => part.value)
      .join("")
      .trim();
    timeString = parts
      .slice(timeStartIndex)
      .map((part) => part.value)
      .join("")
      .trim();
  }

  return {
    date: dateString,
    time: timeString,
  };
};
